module.exports = __webpack_public_path__ + "img/mp3.2b98f3f2.png";